import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewPushListItemComponent } from './new-push-list-item.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxDateBoxModule, DxTextAreaModule , DxCheckBoxModule,  DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxAutocompleteModule, DxSelectBoxModule } from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [NewPushListItemComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    FormsModule,
    ReactiveFormsModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxTextAreaModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxDateBoxModule,
    DxAutocompleteModule
  ],
  exports: [NewPushListItemComponent]
})
export class NewPushListItemModule { }
